export enum BusinessStatus {
  All,
  Casinos,
  Weapons,
  Services,
}
